import React from "react";

import { formateDateToYearMonthDay, LOCALE } from "../utils";
import TooltipText from "./TooltipText";

interface Props {
  readonly date: Date | null;
}

const DateYearMonthDay = ({ date }: Props) => {
  const formattedDate = formateDateToYearMonthDay(date);
  return date == null ? (
    <span>{formattedDate}</span>
  ) : (
    <TooltipText
      text={date.toLocaleTimeString(LOCALE, {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZoneName: "short"
      })}
    >
      {formattedDate}
    </TooltipText>
  );
};

export default DateYearMonthDay;
